export const DURATION = 3000;
export const ERROR_DURATION = 10000;
